import request from "../../utils/request";
const url = process.env.VUE_APP_BASE_API;

const CoursesResource = {
  Lists(params) {
    return request({
      url: `${url}/course-app/list`,
      method: "GET",
      params
    });
  },
  Detail(params) {
    return request({
      url: `${url}/course-app/detail`,
      method: "GET",
      params
    });
  },
  AssetLink(params) {
    return request({
      url: `${url}/course-app/asset-link`,
      method: "GET",
      params
    });
  },
  downLoadFile(url) {
    return request({
      url,
      method: "get",
      responseType: "blob"
    });
  },
  Category(params) {
    return request({
      url: `${url}/course-topic-app/list`,
      method: "GET",
      params
    });
  },
};
export { CoursesResource as default };
